import { getRunAppLink } from "./platform-links";

export const getRefLink = (userId: number): string => {
    const link = getRunAppLink(userId);
    return link || "";
};

export const getPolicyLink = () => `${process.env.REACT_APP_SITE_URL}rules`;

/** JSON — same-origin fetch; с другого домена используйте getFaqJsUrl + loadFaqFromSite */
export const getFaqJsonUrl = () => `${process.env.REACT_APP_SITE_URL}data/faq.json`;

export const getFaqJsUrl = () => `${process.env.REACT_APP_SITE_URL}data/faq.js`;

export const getFaqPath = (query = '') => {
    const suffix = query ? (query.startsWith('?') ? query : `?${query}`) : '';
    return `/faq${suffix}`;
};
